var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('detail',{attrs:{"onManager":_vm.onManager,"data":_vm.detailsData,"hiddenKeys":['created_at', 'updated_at', 'description'],"show-desc":false,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo}}):_c('loading-block',{attrs:{"layout":_vm.loadingLayout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }